import { AbstractFieldWriteComponent } from '../base-field/abstract-field-write.component';
import { Component, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { WriteComplexFieldComponent } from '../complex/write-complex-field.component';
import { AddressModel } from '../../../domain/addresses/address.model';
import { AddressOption } from './address-option.model';
import { AddressesService } from '../../../services/addresses/addresses.service';
import { FormControl, FormGroup } from '@angular/forms';
import { IsCompoundPipe } from '../utils/is-compound.pipe';
import { FocusElementDirective } from '../../../directives/focus-element';

@Component({
  selector: 'ccd-write-address-field',
  template: require('./write-address-field.html'),
  styles: [require('./write-address-field.scss')]
})
export class WriteAddressFieldComponent extends AbstractFieldWriteComponent implements OnInit, OnChanges {

  @ViewChild('writeComplexFieldComponent', {static: true})
  writeComplexFieldComponent: WriteComplexFieldComponent;

  @ViewChildren(FocusElementDirective)
  focusElementDirectives: QueryList<FocusElementDirective>;

  addressesService: AddressesService;

  @Input()
  formGroup: FormGroup;

  addressFormGroup = new FormGroup({});
  postcode: FormControl;
  addressList: FormControl;

  addressOptions: AddressOption[];

  errDisplay = PostCodeLookupError;
  postcodeLookupError: PostCodeLookupError;

  constructor (addressesService: AddressesService, private isCompoundPipe: IsCompoundPipe) {
    super();
    this.addressesService = addressesService;
  }

  ngOnInit(): void {
    if (!this.isComplexWithHiddenFields()) {
      this.postcode = new FormControl('');
      this.addressFormGroup.addControl('postcode', this.postcode);
      this.addressList = new FormControl('');
      this.addressFormGroup.addControl('address', this.addressList);
    }
  }

  findAddress() {
    if (!this.postcode.value) {
      this.postcodeLookupError = PostCodeLookupError.MISSING_POSTCODE;
    } else {
      this.postcodeLookupError = undefined;
      const postcode = this.postcode.value;
      this.caseField.value = null;
      this.addressOptions = new Array();
      this.addressesService.getAddressesForPostcode(postcode.replace(' ', '').toUpperCase()).subscribe(
        result => {
          result.forEach(
            address => {
              this.addressOptions.push(new AddressOption(address, null));
            }
          );
          this.addressOptions.unshift(
            new AddressOption(undefined, this.defaultLabel(this.addressOptions.length))
          );
        }, (error) => {
          if (error.status === 400) {
            this.postcodeLookupError = PostCodeLookupError.BAD_REQUEST;
          } else if (error.status === 429) {
            this.postcodeLookupError = PostCodeLookupError.TRIES_EXHAUSTED;
          } else if (error.status === 500) {
            this.postcodeLookupError = PostCodeLookupError.SERVICE_UNAVAILABLE;
          }
          console.log(`An error occurred retrieving addresses for postcode ${postcode}. ` + JSON.stringify(error));
          this.addressOptions.unshift(
            new AddressOption(undefined, this.defaultLabel(this.addressOptions.length))
          );
        });
      this.addressList.setValue(undefined);
      this.refocusElement();
    }
  }

  refocusElement(): void {
    if (this.focusElementDirectives && this.focusElementDirectives.length > 0) {
      this.focusElementDirectives.first.focus();
    }
  }

  blankAddress() {
    this.caseField.value = new AddressModel();
    this.setFormValue();
  }

  isComplexWithHiddenFields() {
    if (this.caseField.field_type.type === 'Complex' && this.caseField.field_type.complex_fields
      && this.caseField.field_type.complex_fields.some(cf => cf.hidden === true )) {
      return true;
    }
  }

  shouldShowDetailFields() {
    if (this.isComplexWithHiddenFields()) {
      return true;
    }
    if (this.isExpanded) {
      return true;
    }
    if (!this.writeComplexFieldComponent || !this.writeComplexFieldComponent.complexGroup) {
      return false;
    }
    const address = this.writeComplexFieldComponent.complexGroup.value;
    let hasAddress = false;
    if (address) {
      Object.keys(address).forEach(function (key) {
        if (address[key] != null) {
          hasAddress = true;
        }
      });
    }
    return hasAddress;
  }

  addressSelected() {
    this.caseField.value = this.addressList.value;
    this.setFormValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['caseField']) {
      this.setFormValue();
    }
  }

  createId(elementId: string): string {
    return this.id() + '_' + elementId ;
  }

  private defaultLabel(numberOfAddresses) {
    return numberOfAddresses === 0 ? 'No address found'
      : numberOfAddresses + (numberOfAddresses === 1 ? ' address ' : ' addresses ') + 'found';
  }

  private setFormValue() {
    if (this.writeComplexFieldComponent.complexGroup) {
      this.writeComplexFieldComponent.complexGroup.setValue(
        this.caseField.value
      );
    }
  }
}

export enum PostCodeLookupError {
  MISSING_POSTCODE,
  BAD_REQUEST,
  SERVICE_UNAVAILABLE,
  TRIES_EXHAUSTED
}
